import { AxiosError } from "axios";
import mainApi from "../../api/mainApi";
import {
  ClientesResponse,
  SearchClientsResponse,
} from "../../interfaces/clientes/cliente.interface";
import { ClientsByUserResponse } from "../../interfaces/clientes/users-clients.interface";
import { middlewareApi } from "../../middlewares/middlewareApi";

const clientsService = middlewareApi.injectEndpoints({
  endpoints: (builder) => ({
    getClients: builder.query<
      ClientesResponse,
      {
        page: number;
        size: number;
        search?: string;
      }
    >({
      queryFn: async ({ page, size, search }) => {
        try {
          const { data } = await mainApi.get<ClientesResponse>(
            "clientes/getClientes",
            {
              params: {
                page,
                size,
                search,
              },
            }
          );
          return { data };
        } catch (error) {
          let err = error as AxiosError;
          return {
            error: err.request?.data || err.message,
          };
        }
      },
    }),
    createClient: builder.mutation<
      any,
      {
        nombre: string;
        ruc: string;
        correos?: string;
      }
    >({
      queryFn: async ({ nombre, ruc, correos }) => {
        try {
          const { data } = await mainApi.post("clientes/crearCliente", {
            nombre,
            ruc,
            correos,
          });
          return { data };
        } catch (error: any) {
          return { error: error.response.data?.message || error.message };
        }
      },
    }),
    updateClient: builder.mutation<
      any,
      {
        id: number;
        nombre: string;
        ruc: string;
        correos?: string;
      }
    >({
      queryFn: async ({ id, nombre, ruc, correos }) => {
        try {
          const { data } = await mainApi.put("clientes/actualizarCliente", {
            id,
            nombre,
            ruc,
            correos,
          });
          return { data };
        } catch (error) {
          let err = error as AxiosError;
          return {
            error: err.request?.data || err.message,
          };
        }
      },
    }),
    /**
     * @GET
     */
    getClientsByUser: builder.query<
      ClientsByUserResponse,
      {
        id_usuario: number;
        page: number;
        size: number;
        type?: "IMP" | "EXP" | "AMBOS";
      }
    >({
      queryFn: async ({ id_usuario, page, size, type }) => {
        try {
          const { data } = await mainApi.get<ClientsByUserResponse>(
            "usuarios-clientes/getClientsByUser",
            {
              params: {
                id_usuario,
                page,
                size,
                type,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
    /**
     * @GET
     */
    searchClients: builder.query<
      SearchClientsResponse,
      {
        search: string;
      }
    >({
      queryFn: async ({ search }) => {
        try {
          const { data } = await mainApi.get<SearchClientsResponse>(
            "clientes/buscarClientes",
            {
              params: {
                search,
              },
            }
          );
          return { data };
        } catch (error: any) {
          return { error };
        }
      },
    }),
  }),
});

export const {
  useGetClientsQuery,
  useCreateClientMutation,
  useUpdateClientMutation,
  useGetClientsByUserQuery,
  useSearchClientsQuery,
} = clientsService;
